export const CoachKeys = {
    coaches: 'coaches'
};
